import { type ComponentProps } from 'react';
import { Checkbox } from '@material-ui/core';
import { Check } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  checkedIcon: extendedFormsStyle.checkedIcon,
  uncheckedIcon: extendedFormsStyle.uncheckedIcon,
  checked: extendedFormsStyle.checked,
  checkRoot: extendedFormsStyle.checkRoot,
  disabled: {
    '& $checkedIcon,& $uncheckedIcon': {
      borderColor: grayColor[17],
      opacity: 1,
    },
  },
});

type RegularCheckboxProps = {
  customClasses?: {
    root?: string;
  };
} & ComponentProps<typeof Checkbox>;

const RegularCheckbox = ({
  customClasses,
  ...checkboxProps
}: RegularCheckboxProps) => {
  const classes = useStyles();

  return (
    <Checkbox
      checkedIcon={<Check className={classes.checkedIcon} />}
      icon={<Check className={classes.uncheckedIcon} />}
      classes={{
        checked: classes.checked,
        root: classNames(classes.checkRoot, customClasses?.root),
        disabled: classes.disabled,
      }}
      {...checkboxProps}
    />
  );
};

export default RegularCheckbox;
